module.exports = require('./helpers/bundle-url').getBundleURL('lly8x') + "brandlogo3.91f879a0.png" + "?" + Date.now();